import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";

import { UserService } from "./users.service";
import { EmailService } from "./email.service";
import { FormService } from "./form.service";
import { GroupService } from "./group.service";
import { CampaignProjectService } from "./campaign-project.service";
import { CampaignFinanceService } from "./campaignFinance.service";
import { OfferService } from "./offer.service";
import { StatisticService } from "./statistics.service";
import { AlertService } from "./alert.service";
import { NotificationService } from "./notification.service";
import { FlussoService } from "./flusso.service";
import { ChatService } from "./chat.service";
import { LeadFinanceService } from "./leadFinance.service";
import { LeadService } from "./lead.service";
import { StatisticFinanceService } from "./statisticsFinance.service";

const SERVICES = [
  UserService,
  EmailService,
  FormService,
  FlussoService,
  CampaignProjectService,
  CampaignFinanceService,
  OfferService,
  GroupService,
  StatisticService,
  StatisticFinanceService,
  AlertService,
  NotificationService,
  ChatService,
  LeadFinanceService,
  LeadService,
];

@NgModule({
  imports: [CommonModule],
  providers: [...SERVICES],
})
export class ApiModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ApiModule,
      providers: [...SERVICES],
    };
  }
}
